import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

const ThemeProvider = (props) => {
  const { channelId } = useSelector(({ common }) => ({
    channelId: common.channelId,
  }))

  useEffect(() => {
    if (channelId == 'B2C') {
      import('../styles/b2c_colors.css')
    } else {
      import('../styles/b2b_colors.css')
    }
  }, [channelId])

  return props.children
}

export default ThemeProvider
